<template>
    <div class="loader" :class="`loader--${type} loader--${color} loader--${size}`">
        <div class="loader__inner">
            <span></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'inline'
        },
        color: {
            type: String,
            default: 'black'
        },
        size: {
            type: String,
            default: 'regular'
        }
    }
}
</script>

<style scoped lang="scss">
.loader {
    &--fullscreen {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 300;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba($puma-color-neutral-10, 0.2);
    }

    &--small {
        .loader {
            &__inner {
                height: 16px;
                width: 16px;
                span {
                    height: 16px;
                    width: 16px;
                    clip: rect(0, 16px, 16px, 8px);
                    &:after {
                        height: 16px;
                        width: 16px;
                        clip: rect(0, 16px, 16px, 8px);
                    }
                }
            }
        }
    }

    &--white {
        .loader {
            &__inner {
                span {
                    &:after {
                        border-color: white;
                    }
                }
            }
        }
    }

    &__inner {
        height: 32px;
        width: 32px;
        animation: loader-outer 4.8s linear infinite;

        span {
            display: block;
            @include fillout;
            margin: auto;
            height: 32px;
            width: 32px;
            clip: rect(0, 32px, 32px, 16px);
            animation: loader-inner 1.2s linear infinite;

            &:after {
                content: "";
                @include fillout;
                margin: auto;
                height: 32px;
                width: 32px;
                clip: rect(0, 32px, 32px, 16px);
                border: 3px solid black;
                border-radius: 50%;
                animation: loader-inner-after 1.2s cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite;
            }
        }
    }
}

@keyframes loader-outer {
	0%   { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}

@keyframes loader-inner {
	0%   { transform: rotate(0deg); }
	100% { transform: rotate(220deg); }
}

@keyframes loader-inner-after {
	0%   { transform: rotate(-140deg); }
	50%  { transform: rotate(-160deg); }
	100% { transform: rotate(140deg); }
}
</style>